import { Observable, Subject } from 'rxjs';
import { IErrorDescription } from '@ibank-globals/error';
import { ErrorDescription, SourceApis } from './errorDescription';

export class ErrorHandler {
	private static errorSubj: Subject<ErrorDescription> = new Subject();
	public static readonly errorObs: Observable<ErrorDescription> = ErrorHandler.errorSubj.asObservable();

	constructor() {}

	static newError(errorMessage: IErrorDescription, sourceApi: SourceApis = SourceApis.Identity) {
		var error = new ErrorDescription(sourceApi, errorMessage);
		ErrorHandler.errorSubj.next(error);
	}
}
